import { Divider, Text } from "@chakra-ui/react";
import { Indicator } from "../../redux/reducer/indicatorsReducer";
import React from "react";

export default function IndicatorDetail({
  indicator,
}: {
  indicator: Indicator;
}) {
  return (
    <>
      <Text>{indicator?.definition}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Purpose
      </Text>
      <Text>{indicator?.purpose}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Interpretation
      </Text>
      <Text>{indicator?.interpretation}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Calculation method
      </Text>
      <Text>{indicator?.calculation_method}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Type of indicator
      </Text>
      <Text>{indicator?.type}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Unit of Measurement
      </Text>
      <Text>{indicator?.unit_of_measurement}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Frequency of measurement
      </Text>
      <Text>{indicator?.frequency_of_measurement}</Text>
      <Divider my={4} />
      <Text
        style={{
          textAlign: "left",
          fontSize: 16,
          fontWeight: "bold",
          marginBottom: 10,
        }}
      >
        Disaggregation
      </Text>
      <Text>{indicator?.disaggregation}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Performance target
      </Text>
      <Text>{indicator?.performance_target}</Text>
      <Divider my={4} />
      <Text
        style={{
          textAlign: "left",
          fontSize: 16,
          fontWeight: "bold",
          marginBottom: 10,
        }}
      >
        Data Source
      </Text>
      <Text>{indicator?.data_source}</Text>
      <Divider my={4} />
      <Text
        style={{
          textAlign: "left",
          fontSize: 16,
          fontWeight: "bold",
          marginBottom: 10,
        }}
      >
        Limitations
      </Text>
      <Text>{indicator?.limitations}</Text>
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Departments responsible
      </Text>
      {indicator?.departments.map((item, index) => (
        <Text>{item}</Text>
      ))}
      <Divider my={4} />
      <Text style={{ textAlign: "left", fontSize: 16, fontWeight: "bold" }}>
        Technical notes
      </Text>
      <Text>{indicator?.technical_notes}</Text>
    </>
  );
}
